import { render, staticRenderFns } from "./OrganizationDetail.vue?vue&type=template&id=1e3cbd4f&scoped=true"
import script from "./OrganizationDetail.vue?vue&type=script&lang=ts"
export * from "./OrganizationDetail.vue?vue&type=script&lang=ts"
import style0 from "./OrganizationDetail.vue?vue&type=style&index=0&id=1e3cbd4f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e3cbd4f",
  null
  
)

export default component.exports